import { Box, Flex } from '@lemonade-hq/cdk';
import styled from 'styled-components';
import type { HeroProps } from '../renters/Hero';
import { SectionParagraph as Subtitle, SectionTitle as Title } from '@/components/shared/Content';
import JoinCTA from '../shared/JoinCTA';

const BottomCTAContainer = styled(Flex).attrs({ as: 'section' })`
  width: 100%;
  text-align: center;
  position: relative;
  padding: 96px 20px;
  gap: 20px;
`;
const StyledTitle = styled(Title)`
  text-align: center;
`;

const StyledSubtitle = styled(Subtitle)`
  text-align: center;
`;
const Actions = styled(Flex)`
  position: relative;
  z-index: 9;
`;

const CTA = styled(JoinCTA)`
  &&& {
    display: block;
    padding: 18px 44px;
    font-size: 1.8rem;
  }
`;

export const BottomCTA = ({ title, subtitle, ctaLabel, ctaUrl }: HeroProps) => {
  return (
    <BottomCTAContainer pt={[25, 95]} width="100%" alignItems="center" flexDirection="column" zIndex={1}>
      <StyledTitle>{title}</StyledTitle>
      <Actions flexDirection="column" alignItems="center">
        <Box mt={[20, 20, 20]}>
          <CTA
            flavor="primary"
            glowing
            aria-label={ctaLabel}
            id="gtm_button_main_check_prices"
            data-source="top"
            customUrl={ctaUrl}
          >
            {ctaLabel}
          </CTA>
        </Box>
      </Actions>
      <StyledSubtitle>{subtitle}</StyledSubtitle>
    </BottomCTAContainer>
  );
};
